import { getLanguageFromCountry, getValue } from '@/plugins/country/module';

// An amount in the current country's number format: "12 500" (SE),
// "12.500" (NL, DE, DK), and two decimals only when it has any ("9,95").
// The locale strings general_price and general_price_per_month then put the
// currency where the country writes it ("12 500 kr", "€ 12.500").
export function formatAmount(value) {
  const amount = typeof value === 'number' ? value : parseFloat(value);
  if (Number.isNaN(amount)) return '';

  const decimals = Number.isInteger(amount) ? 0 : 2;
  return new Intl.NumberFormat(getLanguageFromCountry(), {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  }).format(amount);
}

export function formatCurrency(value, showSign = true) {
  if (value === null || value === undefined) value = 0;

  if (typeof value !== 'number') {
    value = value.toString().replace(/[^0-9]/g, '');
    value = parseFloat(value);
  }

  if (showSign) {
    return new Intl.NumberFormat(getLanguageFromCountry(), {
      style: 'currency',
      currency: getValue('CURRENCY'),
      minimumFractionDigits: 0
    }).format(value);
  }

  return new Intl.NumberFormat(getLanguageFromCountry(), {
    minimumFractionDigits: 0
  }).format(value);
}
